import { apiUrl } from './api_config'

const AUDIT_ENDPOINT = apiUrl('/audit')

export async function getAuditLog(
  {
    page = 1,
    limit = 25,
    entity = '',
    method = '',
    user = '',
    fromDate = '',
    toDate = '',
  } = {},
  signal,
) {
  const params = new URLSearchParams({
    page: String(page),
    limit: String(limit),
  })
  if (entity) params.set('entity', entity)
  if (method) params.set('method', method)
  if (user) params.set('user', user)
  if (fromDate) params.set('from_date', fromDate)
  if (toDate) params.set('to_date', toDate)

  const response = await fetch(`${AUDIT_ENDPOINT}?${params}`, {
    headers: { 'Content-Type': 'application/json' },
    signal,
  })

  let payload = null
  try {
    payload = await response.json()
  } catch {
    // Preserve the HTTP error when the response has no JSON body.
  }

  if (!response.ok) {
    throw new Error(
      payload?.message ||
        payload?.error ||
        `Audit log request failed (${response.status})`,
    )
  }

  return {
    entries: payload?.entries || [],
    page: payload?.page || page,
    limit: payload?.limit || limit,
    total: payload?.total || 0,
  }
}
